<script lang="ts">
import TextLoader from '@mobile/components/Loader/TextLoader.vue'
import PositionHighlighter from '@mobile/components/PositionHighlighter/PositionHighlighter.vue'
import PressIndicator from '@mobile/components/PressIndicator/PressIndicator.vue'
import RotateScreen from '@mobile/components/RotateScreen/RotateScreen.vue'
import * as alert from '@mobile/globalState/alert'
import * as app from '@mobile/globalState/app'
import {
  active as loaderActive,
  text as loaderText,
} from '@mobile/globalState/loader'
import * as sportsAPI from '@mobile/globalState/sportsAPI'
import Login from '@mobile/views/Login/Login.vue'
import { useLoginFormVisibility } from '@mobile/views/Login/useLoginFormVisibility'

import 'reflect-metadata'

import { computed, defineComponent, toRef } from 'vue'

import { provideRequestUrl } from '@collector/shared-ui-domain'
import { getDeviceSystemInfo } from '@mobile/reusables/utils'

import { useDeviceOrientation } from '../reusables/useDeviceOrientation'
import { useSportsAPILoginForm } from './Login/useSportsAPILoginForm'

export default defineComponent({
  components: {
    PositionHighlighter,
    PressIndicator,
    RotateScreen,
    Login,
    TextLoader,
  },
  setup() {
    const { isVisible: isLoginFormVisible } = useLoginFormVisibility()
    const isDatabaseConnected = toRef(app.state, 'isDatabaseConnected')
    const isClientReady = toRef(sportsAPI.state, 'isClientReady')
    const currentAlert = toRef(alert.state, 'currentAlert')
    const { isPortrait, init: initDeviceOrientation } = useDeviceOrientation()

    const { os, version } = getDeviceSystemInfo()

    initDeviceOrientation()

    const isIos26 = os === 'ios' && version?.startsWith('18')
    const shouldShowRotateScreen = computed(() => isPortrait.value && !isIos26)
    const { requestUrl } = useSportsAPILoginForm()

    provideRequestUrl(requestUrl)
    return {
      loaderText,
      loaderActive,
      currentAlert,
      isLoginFormVisible,
      isDatabaseConnected,
      isClientReady,
      shouldShowRotateScreen,
    }
  },
})
</script>

<template>
  <div
    v-if="loaderActive || currentAlert.component"
    class="absolute inset-0 z-100 grid h-full w-full place-items-center bg-black/90"
  >
    <TextLoader
      v-if="loaderActive"
      :text="loaderText"
    />
    <component
      :is="currentAlert.component"
      v-else-if="currentAlert.component"
      class="flex min-h-40 min-w-120 flex-col items-center justify-center"
      v-on="currentAlert.events"
    />
  </div>
  <PositionHighlighter />
  <PressIndicator />
  <RotateScreen v-if="shouldShowRotateScreen" />
  <Login v-else />
  <RouterView
    v-if="!isLoginFormVisible && isDatabaseConnected && isClientReady"
  />
</template>

<style lang="scss">
@font-face {
  font-family: softnetSPORT-Icons;
  src: url('@mobile/assets/fonts/icons-sports.eot');
  src:
    url('@mobile/assets/fonts/icons-sports.eot') format('embedded-opentype'),
    url('@mobile/assets/fonts/icons-sports.ttf') format('truetype'),
    url('@mobile/assets/fonts/icons-sports.woff') format('woff'),
    url('@mobile/assets/fonts/icons-sports.svg') format('svg');
  font-weight: 400;
  font-style: normal;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.noselect {
  -webkit-touch-callout: none; /* Safari Touch */
  -webkit-user-select: none; /* Webkit */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Edge*/
  user-select: none; /* Future-proof*/
}
</style>
